// Strings for the header of a Loom lead. The wording is the same as the client view's header
// (client.ClientDetail.Status).
export default {
  ClientFeHandoff: {
    Create: 'Create Client-FE lead',
    Creating: 'Creating Client-FE lead…',
    Open: 'Open Client-FE lead',
    Error: 'Could not create the Client-FE lead. Try again or contact an administrator.',
  },
  ChangeName: {
    Title: 'Change name',
    FirstName: 'First name',
    LastName: 'Last name',
    Errors: {
      CLT_004: 'Enter a first and last name.',
      Default: 'Could not save the name. Try again.',
    },
  },
  Subtitles: {
    Created: 'Joined: #{value}',
    Updated: 'Updated: #{value}',
    Day: 'Day #{number}',
  },
  Metrics: {
    PrimaryContact: 'Primary Contact',
    ContactEmail: 'Contact Email',
    ContactPhone: 'Contact Phone',
    IntroCall: 'Intro call',
  },
  Menu: {
    Subtitles: {
      Stage: 'Stage',
      LeadQuality: 'Lead Quality',
    },
  },
};
